<div class="pin-input">
  <p class="desc">{{ description }}</p>
  <div
    #inputs
    [ngClass]="{ 'has-error': hasError }"
    class="inputs"
  >
    <ng-container *ngIf="type === 'PIN'">
      <div
        *ngFor="let input of pinInputs; let i = index"
        class="input"
      >
        <input
          (focusin)="inputFocusIn(i)"
          (keyup)="inputKeyUp($event)"
          [readonly]="readonly"
          maxlength="1"
          secretInput
          inputmode="numeric"
          type="password"
        />
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'OTP'">
      <div
        *ngFor="let input of otpInputs; let i = index"
        class="input"
      >
        <input
          (focusin)="inputFocusIn(i)"
          (keyup)="otpInputKeyUp($event, i)"
          (ngModelChange)="onChange(i, $event)"
          [ngModel]="valueArray[i] || ''"
          [readonly]="readonly"
          autocomplete="one-time-code"
          inputmode="numeric"
          numpad
        />
      </div>
    </ng-container>
  </div>
</div>
